import { Box } from '@wanteddev/wds-engine';
import { forwardRef } from 'react';
import { jsx } from 'react/jsx-runtime';

// src/icon-circle.tsx
var IconCircle = forwardRef((props, ref) => {
  return /* @__PURE__ */ jsx(
    Box,
    {
      as: "svg",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      width: "1em",
      height: "1em",
      ref,
      ...props,
      children: /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M11.9999 3.9001C7.52641 3.9001 3.89991 7.52659 3.89991 12.0001C3.89991 16.4736 7.52641 20.1001 11.9999 20.1001C16.4734 20.1001 20.0999 16.4736 20.0999 12.0001C20.0999 7.52659 16.4734 3.9001 11.9999 3.9001ZM2.09991 12.0001C2.09991 6.53248 6.5323 2.1001 11.9999 2.1001C17.4675 2.1001 21.8999 6.53248 21.8999 12.0001C21.8999 17.4677 17.4675 21.9001 11.9999 21.9001C6.5323 21.9001 2.09991 17.4677 2.09991 12.0001Z",
          fill: "currentColor"
        }
      )
    }
  );
});
var icon_circle_default = IconCircle;

export { icon_circle_default as default };
